import React from "react";
import { AddressLine, AddressPhone, CardFooter, CardWrapper, DefaultTitle, EditAction, Name } from "../assets/style";
import { CheckBox } from "components/CheckBox";


/**
 * @description
 * address card component which renders individual address elements
 * @param AddressCardProps
 * @returns - card component
 */
export const AddressCard = ({
  isDefault,
  tag,
  isChecked = false,
  address,
  handleCheckBoxClick,
  handleEditClick,
  defaultTitle,
  editTitle,
}: AddressCardProps) => {
  const {
    firstName,
    city,
    postcode,
    region,
    street,
    phone,
    customerAddressId,
  } = address;


  return (
    <CardWrapper isChecked={isChecked} onClick={() => handleCheckBoxClick(address)}>
      <div className="layout vertical">
        {
          isDefault && (
            <div className="layout horizontal center mb4">
              <DefaultTitle>{defaultTitle}</DefaultTitle>
              <CheckBox
                isChecked={isChecked}
              />
            </div>
          )
        }
        <div className="layout horizontal center mb4">
          <Name>{firstName}</Name>
          {/* tag can be passed as per design when received from backend in future */}
          {
            tag && (
              <div className="label">
                {tag}
              </div>
            )
          }
          {
            !isDefault && (
              <CheckBox
                isChecked={isChecked}
              />
            )
          }
        </div>
      </div>
      <div className="layout vertical address" data-testid="txt_address_bar">
        <AddressLine>{street}, {region}</AddressLine>
        <AddressLine>{city}-{postcode}</AddressLine>
      </div>
      <CardFooter>
        <AddressPhone>{phone}</AddressPhone>
        {/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <EditAction
          data-testid="address_edit_btn"
          onClick={() => handleEditClick(customerAddressId)}
        >
          {editTitle}
        </EditAction>
      </CardFooter>
    </CardWrapper>
  );
};
